import styled from 'styled-components';

export const ImportantInfoStyles = styled.div`
    font-weight: bold;
    color: var(--white);
    ${props => props.alignLeft && 'text-align: left'};
    ${props => props.marginTop && 'margin-top: 2rem'};
`;
